<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80 jsonPopup"
          :style="{ 'max-height': getMaxHeightClient() + 'px' }"
          @mousedown="dontClose">
          <div>
            <b-row>
              <b-col style="text-align:end;">
                <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
              </b-col>
            </b-row>
          </div>
          <div class="modal-body" style="overflow:auto;" :style="{'max-height' : ((getMaxHeightClient() * 0.85)) + 'px'}">
            <b-container fluid>
              <b-row v-if="isPopupActive">
                <div class="break h5"><pre lang="json"><code v-html="highlightedJsonData"></code></pre></div>
              </b-row>
            </b-container>
          </div>
          <div class="modal-footer">
            <b-col lg="2" sm="3" cols="6" class="p-0 m-0">
              <b-button variant="primary" @click="download(jsonDetailsData.data)">{{ $t('common.dwnld') }}</b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import moment from 'moment'
import backButton from '@/components/common/backButton.vue'
import {downloadFileWithDefinedHeaders} from '@/helpers/download'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-csv'
import xmlFormatter from 'xml-formatter'
const { DOMParser } = require('xmldom')

export default {
  name: 'CMJsonDetails',
  components: {
    'back-button': backButton
  },
  props: {
    jsonDetailsData: {
      type: Object
    }
  },
  data () {
    return {
      isPopupActive: true,
      highlightedJsonData: '',
      mousedown: false,
      jsonData: ''
    }
  },
  watch: {
    jsonData: {
      handler () {

        if (this.jsonData.length > 0) {
          if (this.isXML(this.jsonData)) {
            const formattedJson = xmlFormatter(this.jsonData)
            this.highlightedJsonData = Prism.highlight(formattedJson, Prism.languages.json)
          } else if (this.isJSON(this.jsonData)) {
            this.highlightedJsonData = Prism.highlight(JSON.stringify(JSON.parse(this.jsonData), null, 2), Prism.languages.json, 'json')
          } else if (this.isCSV(this.jsonData)) {
            const jsonData = this.csvToJson(this.jsonData)
            this.highlightedJsonData = Prism.highlight(this.jsonToCsv(jsonData), Prism.languages.csv, 'txt')
          } else {
            this.highlightedJsonData = Prism.highlight(this.jsonData, Prism.languages.plaintext || Prism.languages.text || {}, 'txt')
          }
        }
      },
      immediate: true // Appeler la méthode lors de la création du composant
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
    if(this.isXML(this.jsonDetailsData.data)){
      this.jsonData = this.jsonDetailsData.data
    }
    else if(this.isJSON(this.jsonDetailsData.data)){
      this.jsonData = this.jsonDetailsData.data
    }
    else if(this.isCSV(this.jsonDetailsData.data)){
      this.jsonData = this.jsonDetailsData.data
    }
    else{
      this.jsonData = this.jsonDetailsData.data
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {jsonToCsv(jsonData) {
      const jsonArray = Array.isArray(jsonData) ? jsonData : [jsonData];
      const headers = Object.keys(jsonArray[0]);

      const csvRows = [
        headers.join(','),
        ...jsonArray.map(row => headers.map(fieldName => JSON.stringify(row[fieldName], this.replacer)).join(','))
      ];

      return csvRows.join('\n');
    },
    replacer(key, value) {
      return value === null ? '' : value;
    },
    csvToJson(csvString) {
      const lines = csvString.split('\n');
      const result = [];
      const headers = lines[0].split(';'); // Utiliser ; comme séparateur

      for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentline = lines[i].split(';'); // Utiliser ; comme séparateur

        for (let j = 0; j < headers.length; j++) {
          obj[headers[j].trim()] = currentline[j] ? currentline[j].trim() : null; // Trim pour enlever les espaces
        }
        result.push(obj);
      }

      return result; // Retourne un tableau d'objets
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    isXML (str) {
      try {
        const parser = new DOMParser()
        const jsonDoc = parser.parseFromString(str, 'text/xml')
        return jsonDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight - 50
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight - 50
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    },
    see (data) {
      data = Buffer.from(data, 'base64')
      data = data.toString()
      return data
    },
    download (data) {
      let extension = ''
      if (this.isJSON(this.jsonData)) {
        extension = '.json'
        const blob = new Blob([data], { type: 'application/json' })
        const fileName = moment().format('YYYYMMDD_hhmmss_') + this.jsonDetailsData.type + extension
        downloadFileWithDefinedHeaders(this, fileName, URL.createObjectURL(blob))
        this.$emit('close')
      }
      else if (this.isXML(this.jsonData)) {
        extension = '.xml'
        const blob = new Blob([data], { type: 'text/xml' })
        const fileName = moment().format('YYYYMMDD_hhmmss_') + this.jsonDetailsData.type + extension
        downloadFileWithDefinedHeaders(this, fileName, URL.createObjectURL(blob))
        this.$emit('close')
      }
      else if (this.isCSV(this.jsonData)) {
        extension = '.csv'
        const blob = new Blob([data], { type: 'text/csv' })
        const fileName = moment().format('YYYYMMDD_hhmmss_') + this.jsonDetailsData.type + extension
        downloadFileWithDefinedHeaders(this, fileName, URL.createObjectURL(blob))
        this.$emit('close')
      }
      else {
        extension = '.txt'
        const blob = new Blob([data], { type: 'text/plain' })
        const fileName = moment().format('YYYYMMDD_hhmmss_') + this.jsonDetailsData.type + extension
        downloadFileWithDefinedHeaders(this, fileName, URL.createObjectURL(blob))
        this.$emit('close')
      }


    }
  }
}
</script>
<style scoped>
.jsonPopup {
  max-height: 80%;
  padding: 1rem;
  overflow: hidden;
}

.break {
  /* word-break: break-all; */
}
</style>
